<template>
  <div class="traits">
    <div class="traits__progress" :class="'traits__progress--demo-'+answers.length"></div>

    <div class="traits__header">
      <img class="traits__logo" :src="'/static/img/rocket-' + rocketNo + '.svg'" alt="">
    </div>

    <div class="traits__content">

      <div v-for="(indicator, index) in indicators" class="indicator" :key="indicator.id">

        <h3 class="indicator__title">
          {{ index + 1 }}. {{ indicator.body }}
        </h3>

        <div class="indicator__rates">
          <label v-for="(rate, index) in 6"
            @click="selectAnswer({selection: index, indicator_id: indicator.id}, indicator.reverse)"
            class="rate" :class="'rate--'+index" :key="rate.id">
            <input class="rate__radio" type="radio" :value="index" :name="'indicator-'+indicator.id">
            <span class="rate__checkmark" :class="'rate__checkmark--'+index"></span>
            <span v-if="index === 0" class="rate__text">Disagree</span>
            <span v-else-if="index === 5" class="rate__text">Agree</span>
          </label>
        </div>

      </div>

    </div>

    <div class="traits__footer d-flex justify-content-between mt-4">
      <div class="traits__control">
        <router-link class="custom-btn custom-btn--green mx-0" :to="{ name: 'demoSections' }">Back</router-link>
      </div>
      <div class="traits__counter">{{ answers.length }} / {{ indicators.length }}</div>
      <div class="traits__control">
        <button @click="completeSection" v-if="allFilled" class="custom-btn custom-btn--green mx-0">
          Complete Section
        </button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: ['indicators', 'section', 'sectionOrder'],
  data() {
    return {
      answers: [],
      evaluationResults: {},
    };
  },
  computed: {
    allFilled() {
      return this.answers.length === this.indicators.length;
    },
    rocketNo() {
      return parseInt(this.sectionOrder, 10) + 1;
    },
  },
  methods: {
    selectAnswer(answer, reverse) {
      const answerObj = answer;
      if (reverse) {
        answerObj.selection = Math.abs(answerObj.selection - 5);
      }
      for (let i = 0; i < this.answers.length; i += 1) {
        if (this.answers[i].indicator_id === answerObj.indicator_id) {
          this.answers[i] = answerObj;
          return;
        }
      }
      this.answers.push(answerObj);
    },
    completeSection() {
      if (this.section === 'Real Empowerment') {
        this.$store.commit('finishSection', {
          Empowerment: true,
        });
      } else {
        this.$store.commit('finishSection', {
          [this.section]: true,
        });
      }
      this.$store.commit('submitAnswers', {
        subjectAnswers: this.answers,
        subjectOrder: this.sectionOrder,
      });
      this.$router.push({ name: 'demoSections', params: { finishedName: this.section } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Demo/Indicators.vue